export const musicList = [
  { name: '0321', artist: '', duration: '03:14', file: '0321.mp3' },
  { name: 'Angel', artist: '', duration: '04:15', file: 'Angel.mp3' },
  { name: 'Bloom', artist: '', duration: '04:00', file: 'Bloom.m4a' },
  { name: 'Coldest Winter', artist: '', duration: '03:47', file: 'Coldest Winter.mp3' },
  { name: 'Die For You', artist: 'The Weeknd', duration: '04:20', file: 'Die For You.mp3' },
  { name: 'Let Go', artist: '', duration: '02:57', file: 'Let Go.mp3' },
  { name: 'Million Days', artist: '', duration: '03:28', file: 'Million Days.mp3' },
  { name: 'Moonlight Romance', artist: '', duration: '03:34', file: 'Moonlight Romance.m4a' },
  { name: 'Sacred Play Secret Place', artist: '', duration: '05:17', file: 'Sacred Play Secret Place.mp3' },
  { name: 'So Far Gone', artist: '', duration: '03:32', file: 'So Far Gone.mp3' },
  { name: 'Sway', artist: '', duration: '03:30', file: 'Sway.mp3' },
  { name: 'Trouble I\\\\\'m In', artist: '', duration: '03:20', file: 'Trouble I\'m In.mp3' },
  { name: 'Turn The Page', artist: '', duration: '02:37', file: 'Turn The Page.mp3' },
  { name: 'Very Miss U', artist: '', duration: '03:09', file: 'Very Miss U.mp3' },
  { name: 'Wasted (Nightcore) (feat. harmony haven)', artist: '', duration: '03:14', file: 'Wasted (Nightcore) (feat. harmony haven).m4a' },
  { name: 'differences', artist: '', duration: '02:27', file: 'differences.m4a' },
  { name: 'for ya', artist: '', duration: '02:33', file: 'for ya.mp3' },
  { name: 'kids', artist: '', duration: '02:38', file: 'kids.m4a' },
  { name: '♡B l u e °F', artist: '', duration: '03:14', file: '♡B l u e °F.mp3' },
  { name: '一点', artist: '', duration: '03:20', file: '一点.mp3' },
  { name: '不想让你走', artist: '', duration: '03:13', file: '不想让你走.mp3' },
  { name: '如果可以', artist: '', duration: '04:34', file: '如果可以.mp3' },
  { name: '形容', artist: '', duration: '04:29', file: '形容.mp3' },
  { name: '清空', artist: '', duration: '02:57', file: '清空.mp3' },
  { name: '爱怎么了', artist: '', duration: '03:59', file: '爱怎么了.mp3' },
  { name: '爱情讯息', artist: '', duration: '04:40', file: '爱情讯息.mp3' },
  { name: '第57次取消发送', artist: '', duration: '03:00', file: '第57次取消发送.mp3' },
  { name: '迷失幻境', artist: '', duration: '02:36', file: '迷失幻境.mp3' },
  { name: '追寻你', artist: '', duration: '03:15', file: '追寻你.mp3' }
];
